"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('underscore'),
  last = _require.last,
  first = _require.first;
var PAGE_LIMIT = 10;
var OrgEntitlementTransactions = /*#__PURE__*/function () {
  OrgEntitlementTransactions.$inject = ["$rootScope", "$scope", "entitlementsService"];
  /* @ngInject */
  function OrgEntitlementTransactions($rootScope, $scope, entitlementsService) {
    _classCallCheck(this, OrgEntitlementTransactions);
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.entitlementsService = entitlementsService;
  }

  /**
   * Initializes data
   */
  return _createClass(OrgEntitlementTransactions, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.getOrganizationTransactions().then(function (transactionsPage) {
        _this.transactionsPage = transactionsPage;
      }).catch(function (err) {
        console.error(err);
        _this.transactionsPage = {
          error: 'An error occured getting transactions information.'
        };
      });
      this.$scope.$on('LOAD_PREVIOUS_TRANSACTION_PAGE', function () {
        var firstTransaction = first(_this.transactionsPage.items);
        _this.getOrganizationTransactions({
          startAt: firstTransaction._id
        }).then(function (transactionsPage) {
          _this.transactionsPage = transactionsPage;
        }).catch(function (err) {
          console.error(err);
          _this.$rootScope.setFlashMessage('An error occured getting transactions information.', 'danger');
        });
      });
      this.$scope.$on('LOAD_NEXT_TRANSACTION_PAGE', function () {
        var lastTransaction = last(_this.transactionsPage.items);
        _this.getOrganizationTransactions({
          endAt: lastTransaction._id
        }).then(function (transactionsPage) {
          _this.transactionsPage = transactionsPage;
        }).catch(function (err) {
          console.error(err);
          _this.$rootScope.setFlashMessage('An error occured getting transactions information.', 'danger');
        });
      });
    }

    /**
     * Fetches the transactions history for the current organization
     *
     * @param {object} page - The object specifying the pagination
     */
  }, {
    key: "getOrganizationTransactions",
    value: function getOrganizationTransactions() {
      var _this2 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        first: true
      };
      if (this.loading) return;
      this.loading = true;
      return this.entitlementsService.getOrganizationTransactions(this.organisation._id, [this.entitlementsService.TYPE_ACCOUNT, this.entitlementsService.TYPE_TRANSACTION, this.entitlementsService.TYPE_EXPIRED], Object.assign(page, {
        limit: PAGE_LIMIT
      })).then(function (transactionsPage) {
        return transactionsPage;
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlement-transactions', ['backstage.services']).component('bsOrgEntitlementTransactions', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlement-transactions/org-entitlement-transactions.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementTransactions
}).name;